"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoBar = void 0;

var _react = require("@lingui/react");

var _react2 = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

const Container = _styledComponents.default.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  width: 100%;
`;
const Column = _styledComponents.default.div`
  display: inline-flex;
  flex: 1;
`;
const Left = (0, _styledComponents.default)(Column)`
  margin-right: auto;
`;
const Center = (0, _styledComponents.default)(Column)`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
`;
const Right = (0, _styledComponents.default)(Column)`
  margin-left: auto;
`;
const StyledDisplaySmall = (0, _styledComponents.default)(_blocks.DisplaySmall)`
  display: flex;
  align-items: center;
  margin: 0 ${_blocks.spacing.tight};
  color: ${_blocks.color.theme.typography.ink};
`;
const Icon = _styledComponents.default.div`
  margin: ${_blocks.spacing.extraTight} ${_blocks.spacing.tight} ${_blocks.spacing.extraTight} 0;
`;

const InfoBar = ({
  siteCount,
  insightsCount,
  equipCount,
  timeRange
}) => {
  return /*#__PURE__*/_react2.default.createElement(Container, null, /*#__PURE__*/_react2.default.createElement(Left, null), /*#__PURE__*/_react2.default.createElement(Center, null, /*#__PURE__*/_react2.default.createElement(StyledDisplaySmall, {
    as: "span"
  }, /*#__PURE__*/_react2.default.createElement(Icon, null, /*#__PURE__*/_react2.default.createElement(_blocks.SiteOutline, {
    fillColor: _blocks.color.theme.supportingColor.subdued
  })), /*#__PURE__*/_react2.default.createElement("strong", null, siteCount, ' ', /*#__PURE__*/_react2.default.createElement(_react.Trans, {
    id: "analysis.sites",
    values: {
      siteCount: siteCount
    }
  }))), /*#__PURE__*/_react2.default.createElement(StyledDisplaySmall, {
    as: "span"
  }, /*#__PURE__*/_react2.default.createElement(Icon, null, /*#__PURE__*/_react2.default.createElement(_blocks.InsightsListOutline, {
    fillColor: _blocks.color.theme.supportingColor.subdued
  })), /*#__PURE__*/_react2.default.createElement("strong", null, insightsCount, ' ', /*#__PURE__*/_react2.default.createElement(_react.Trans, {
    id: "analysis.analyses",
    values: {
      insightsCount: insightsCount
    }
  }))), /*#__PURE__*/_react2.default.createElement(StyledDisplaySmall, {
    as: "span"
  }, /*#__PURE__*/_react2.default.createElement(Icon, null, /*#__PURE__*/_react2.default.createElement(_blocks.EquipsItemOutline, {
    fillColor: _blocks.color.theme.supportingColor.subdued
  })), /*#__PURE__*/_react2.default.createElement("strong", null, equipCount, ' ', /*#__PURE__*/_react2.default.createElement(_react.Trans, {
    id: "analysis.equips",
    values: {
      equipCount: equipCount
    }
  }))), /*#__PURE__*/_react2.default.createElement(StyledDisplaySmall, {
    as: "span"
  }, /*#__PURE__*/_react2.default.createElement(Icon, null, /*#__PURE__*/_react2.default.createElement(_blocks.CalendarListOutline, {
    fillColor: _blocks.color.theme.supportingColor.subdued
  })), /*#__PURE__*/_react2.default.createElement("strong", null, timeRange))), /*#__PURE__*/_react2.default.createElement(Right, null));
};

exports.InfoBar = InfoBar;